import * as React from "react";
import { cn } from "@/lib/utils";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(function Input(
  { className, type = "text", ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        "h-8 w-full min-w-0 rounded-md border border-input bg-card px-2.5 text-[13.5px] text-foreground transition-[border-color,box-shadow] outline-none",
        "focus-visible:border-foreground/40 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-foreground/8",
        "disabled:opacity-50 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
});

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(function Textarea(
  { className, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        "w-full min-w-0 resize-none rounded-md border border-input bg-card px-2.5 py-2 text-[14px] leading-relaxed text-foreground outline-none",
        "focus-visible:border-foreground/40 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-foreground/8",
        className,
      )}
      {...props}
    />
  );
});

export function Label({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn("text-[13px] font-medium text-foreground", className)} {...props} />;
}

export function Kbd({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <kbd
      className={cn(
        "inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-[4px] border border-border bg-muted px-1 font-sans text-[11px] font-medium text-muted-foreground",
        className,
      )}
    >
      {children}
    </kbd>
  );
}

export function Separator({ className, vertical }: { className?: string; vertical?: boolean }) {
  return <div role="separator" className={cn(vertical ? "mx-1 h-4 w-px" : "my-1 h-px w-full", "bg-border", className)} />;
}
